import { Account } from '../../types/account';

export const isTrialUser = (type?: Account) => type === undefined || type === Account.TRIAL;
